import * as React from "react";
const SvgTextItalicFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M20 2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm-3 2h-6a1 1 0 1 0 0 2h1.581L8.295 18H6.933a1 1 0 1 0 0 2h6.084a1 1 0 1 0 0-2h-1.599l4.286-12H17a1 1 0 1 0 0-2", clipRule: "evenodd" }));
export default SvgTextItalicFill;
